import { useCallback, useEffect, useState } from 'react';
import { useForm } from '../forms/useForm';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { ModalCreateSpecimen, ModalUpdateSpecimen, ModalDeleteSpecimen, LostConnection } from '../../constant';
import { validarSesion } from '../tokens/useToken';
import { useHistory } from 'react-router-dom';
import { sendRequest } from '../requests/useRequest';
import { usePagination} from '../pagination/usePagination';


export const useSpecimens = ({activeTab}) => {

    const history = useHistory();
    
    const [specimens, setSpecimens] = useState([]);
    const [specimenId, setSpecimenId] = useState(0);

    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");

    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();

    // ? Delete dialog
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);

    // ? SEARCH
    const [searchSpecimen, setSearchSpecimen] = useState("");
    const [specimenBackup, setSpecimenBackup] = useState([]);
    const [loadingExcel, setLoadingExcel] = useState(false);

    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        name: "",
        abbreviation: ""
    });

    const { name, abbreviation } = formValues;

    const [validaciones, setValidaciones] = useState({
        name_valid: false,
        abbreviation_valid: false
    });

    const numberItems = 10;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(specimens.length, numberItems);

    useEffect(() => {
        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;
        let listspecimens = [];
        specimens.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listspecimens.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setSpecimens(listspecimens);
    }, [totalPageCount, currentPage])


    // const toggle = () => {
    //     setModal(!modal);
    // }

    const openDialog = (title, mode) => {
        setModalTitle(title);
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };

   
     const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setShowDeleteAlert(false); 
        setModalAlert(false);   
    };
    

    useEffect( () => {
        getSpecimens();
    }, [activeTab]);

    const getSpecimens = useCallback(async () => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "Specimen/List");

        if (respuesta.code === 200) {
            let listSpecimen = [];
            let startItems = 0;
            let endItems = numberItems;
            let aux = numberItems * currentPage;

            endItems = aux;

            startItems = endItems - numberItems;

            ////console.log(respuesta);

            if (respuesta.data.length >= 1) {


                respuesta.data.forEach( (data,index) => {
                    
                let posicion = index + 1;
                let visibleTable = false;
                
                if (posicion > startItems && posicion <= endItems) {
                    visibleTable = true;
                }

                    listSpecimen.push({
                        id_specimen: data.id_specimen,
                        name: data.name,
                        abbreviation: data.abbreviation,
                        visibleTable: visibleTable

                    });
                });

                setSpecimens(listSpecimen);
                setSpecimenData(listSpecimen);
                setSpecimenBackup(listSpecimen); 
            }
            else{
                createSweet("error", "error", "Hubo un error!", "No se encontraron datos");
                setSpecimens([]);
            }
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, getSpecimens);
        }
        else if(respuesta.code === 500){
            createSweet("error", "error", "Especimen", "Ocurrio un problema en el servidor");
        }
        else{
            createSweet("error", "warning", "Especimen", respuesta.data.msg);
        }
    }, [history]);

    useEffect(() => {
        
        getSpecimens();

    }, [getSpecimens]);

    const handleCreate = () => {
        handleUpdateValues({
            name: "",
            abbreviation: ""
        });

        setValidaciones({
            name_valid: false,
            abbreviation_valid: false
        });

        setSpecimenId(0);
        setMethod("create");
        setModalTitle(ModalCreateSpecimen);
        openDialog("Nuevo especímen", "create");
    }   

    const saveCreate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let mValues = JSON.stringify(formValues);

        let requestOptions = {
            method: 'POST',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "Specimen");
        if (respuesta.code === 200) {
            getSpecimens();
            reset();
            createSweet("create", "success", "Exito!", "Especímen creado con exito");
            setLoading(false);
            closeDialog();
        }
        else if (respuesta.code === 401) {
            setLoading(false);
            validarSesion(history, respuesta.code, saveCreate);
        }
        else if(respuesta.code === 500){
            setLoading(false);
            createSweet("error", "error", "Especímen", "Ocurrio un problema en el servidor");
        }
        else{
            setLoading(false);
            createSweet("error", "warning", "Especímen", respuesta.data.msg);
        }
    }

    const handleUpdate = (id_specimen) => {
        let specimen = specimens.find(s => s.id_specimen === id_specimen);

        handleUpdateValues({
            name: specimen.name,
            abbreviation: specimen.abbreviation
        });

        setValidaciones({
            name_valid: false,
            abbreviation_valid: false
        });

        setSpecimenId(id_specimen);
        setMethod("update");
        setModalTitle(ModalUpdateSpecimen);
        openDialog("Editar especímen", "update");
    }

    const saveUpdate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let body = {
            id_specimen: specimenId,
            ...{ ...formValues }
        };

        let mValues = JSON.stringify(body);
        
        let requestOptions = {
            method: 'PUT',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "Specimen/Update");

        if (respuesta.code === 200) {
            getSpecimens();
            createSweet("create", "success", "Exito!", "Especímen actualizado");
            setLoading(false);
            closeDialog();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
        }
        else if(respuesta.code === 500){
            createSweet("error", "error", "Especímen", "Ocurrio un problema en el servidor");
        }
        else{
            createSweet("error", "warning", "Especímen", respuesta.data.msg);
        }
    }

    const handleDelete = (id_specimen) => {
        let specimen = specimens.find(s => s.id_specimen === id_specimen);

        handleUpdateValues({
            name: specimen.name,
            abbreviation: specimen.abbreviation
        });

        setSpecimenId(id_specimen);
        setMethod("delete");
        setModalTitle(ModalDeleteSpecimen);
        openDeleteAlert();
    }

    const saveDelete = async (e) => {
        e.preventDefault();

        setLoading(true);

        let requestOptions = {
            method: 'DELETE'
        };

        const respuesta = await sendRequest(requestOptions, `Specimen/${specimenId}`);

        if (respuesta.code === 200) {
            getSpecimens();
            setLoading(false);
            createSweet("create", "siccess", "Exito!", "Especímen eliminado");
            closeDeleteAlert();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveDelete);
        }
        else if(respuesta.code === 500){
            createSweet("error", "error", "Especímen", "Ocurrio un problema en el servidor");
        }
        else{
            createSweet("error", "warning", "Especímen", respuesta.data.msg);
        }

    }

    const validarForm = () => {
        let statusValidation = false;
        let newValidations = {};

        if (formValues.name.length < 3) {
            newValidations = {
                ...newValidations,
                name_valid: true
            };
            statusValidation = true;
        }
        else{
            newValidations = {
                ...newValidations,
                name_valid: false
            };
        }

        if (formValues.abbreviation.length < 2) {
            newValidations = {
                ...newValidations,
                abbreviation_valid: true
            };
            statusValidation = true;
        }
        else{
            newValidations = {
                ...newValidations,
                abbreviation_valid: false
            };
        }

        setValidaciones(newValidations);

        return statusValidation;
    }

    const [specimenData, setSpecimenData] = useState([]);



    const handleSearchSpecimen = (value) => {

        const text = typeof value === "string"
            ? value
            : value?.target?.value || "";

        setSearchSpecimen(text);

        if (text === "") {
            setSpecimens(specimenBackup);
            return;
        }

        const filtered = specimenBackup.filter(item =>
            item.name?.toUpperCase().includes(text.toUpperCase()) ||
            item.abbreviation?.toUpperCase().includes(text.toUpperCase())
        );

        setSpecimens(filtered);
    };

    const handleClearSpecimen = () => {
        setSearchSpecimen("");
        setSpecimens(specimenBackup);
    };

    const handleExcelSpecimens = async () => {
        setLoadingExcel(true); 

        try {
            const XLSX = await import("xlsx");

            const data = specimens.map((item, index) => ({
                "#": index + 1,
                "ID": item.id_specimen,
                "Nombre": item.name || "----",
                "Abreviatura": item.abbreviation || "----"
            }));

            const worksheet = XLSX.utils.json_to_sheet(data);

            worksheet["!cols"] = [
                { wch: 5 },
                { wch: 10 },
                { wch: 40 },
                { wch: 20 }
            ];

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Especímenes");

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });

            const blob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "Catalogo_Especimenes.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }

        setLoadingExcel(false); 
    };
    return {
        specimens, method,
        handleInputChange, validaciones,
        name, abbreviation,
        closeDialog, modal, modalTitle, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,handleSearchSpecimen,
        modalAlert, showDeleteAlert, closeDeleteAlert, 
        loadingExcel, handleExcelSpecimens,
        handleClearSpecimen, searchSpecimen


    }
}
